import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryPurchaseOrderGRN } from "./thunk";

interface InitialStateType {
  inventoryPurchaseOrderGRNList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: InitialStateType = {
  inventoryPurchaseOrderGRNList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryPurchaseOrderGRNSlice = createSlice({
  name: "InventoryPurchaseOrder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryPurchaseOrderGRN.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryPurchaseOrderGRN.fulfilled, (state, action) => {
        state.loading = false;
        state.inventoryPurchaseOrderGRNList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryPurchaseOrderGRN.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Network Error";
      });
  },
});

export default InventoryPurchaseOrderGRNSlice.reducer;
